var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDenmark1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "denmark 1",
    clipPath: "url(#clip0_1626_390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.26096 6.95653H15.9323C15.421 3.03131 12.0646 0 8.00005 0C7.40271 0 6.82093 0.0660313 6.26093 0.190156L6.26096 6.95653Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.17394 6.95644V0.972656C1.97728 2.17122 0.404718 4.36969 0.067749 6.95647L4.17394 6.95644Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.1739 9.04297H0.067749C0.404718 11.6298 1.97728 13.8282 4.17394 15.0268L4.1739 9.04297Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.26093 9.043V15.8093C6.82093 15.9335 7.40271 15.9995 8.00005 15.9995C12.0646 15.9995 15.421 12.9682 15.9323 9.04297H6.26093V9.043Z",
    fill: "#D80027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenmark1);
export default __webpack_public_path__ + "static/media/denmark 1.61935249bcdba8b7d43a4b37e88de053.svg";
export { ForwardRef as ReactComponent };